import { FileSizePipe } from '@/extensions/fileSizePipe';
import { PropertyHelper } from '@/helpers/property.helper';
import { ActionService } from '@/services/action.service';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SafeUrl } from '@angular/platform-browser';
import { DocumentSummary } from '@eemo/api-client';

@Component({
  selector: 'app-doc-summary-card',
  standalone: true,
  imports: [FileSizePipe, MatIconModule, NgIf, NgTemplateOutlet],
  templateUrl: './doc-summary-card.component.html',
  styleUrl: './doc-summary-card.component.css'
})
export class DocSummaryCardComponent implements OnInit {
  @Input() title: string;
  @Input() document: DocumentSummary;

  tooltip: string;
  iconClass: string;
  url: SafeUrl;
  filename: string;
  viewable: boolean;

  constructor(private propHelper: PropertyHelper, private actionService: ActionService) {}

  ngOnInit(): void {
    this.tooltip = this.propHelper.getFileTooltipFromMimeType(this.document.mimeType);
    this.iconClass = this.propHelper.getFileIconFromMimeType(this.document.mimeType);
    this.url = this.propHelper.getDocumentUrl(this.document);
    this.filename = this.propHelper.getDocumentFilename(this.document);
    this.viewable = this.propHelper.isDocumentViewable(this.document);
  }

  viewDoc() {
    this.actionService.viewDoc(this.document);
  }
}
